import {
    GET_PAYMENT,
    GET_PAYMENT_SUCCESS,
    GET_PAYMENT_ERROR,
    GET_PAYMENT_METHOD,
    GET_PAYMENT_METHOD_SUCCESS,
    GET_PAYMENT_METHOD_ERROR,
    GET_PAYMENT_METHOD_CREATED_BY,
    GET_PAYMENT_METHOD_CREATED_BY_SUCCESS,
    GET_PAYMENT_METHOD_CREATED_BY_ERROR,
  } from "../actions";

  const INIT_STATE = {
    paymentId: null,
    payment: [],
    contactDetailsError: "",
    paymentMethodId: null, 
    paymentMethod: null,
    getPaymentMethodError: null,
    paymentCreatedById: null,
    paymentCreatedBy: null,
    paymentCreatedByError: null,
  
  };

  export default (state = INIT_STATE, action) => {
    switch (action.type) {
      
      case GET_PAYMENT:
   
        return {
          ...state,
          loading: true,
         paymentDetailsError: "",
         paymentId: action.payload.paymentId,
        };
      case GET_PAYMENT_SUCCESS:
        return {
          ...state,
          loading: false,
         paymentDetailsError: "",
         payment: action.payload.payment,
     
        };

        case GET_PAYMENT_ERROR:
        return { ...state, loading: false,paymentDetailsError: action.payload ? action.payload.message : "" };

        case GET_PAYMENT_METHOD:
          return { ...state, loading: true, paymentMethodId: action.payload.methodId};
        case GET_PAYMENT_METHOD_SUCCESS:
          return { ...state, loading: false, getPaymentMethodError: "", paymentMethod: action.payload.paymentMethod };
        case GET_PAYMENT_METHOD_ERROR:
          return { ...state, loading: false, getPaymentMethodError: action.payload ? action.payload.message : "" };
        case GET_PAYMENT_METHOD_CREATED_BY:
          return { ...state, loading: true, paymentCreatedById: action.payload.createdById};
        case GET_PAYMENT_METHOD_CREATED_BY_SUCCESS:
          return { ...state, loading: false, paymentCreatedByError: "", paymentCreatedBy: action.payload.contact };
        case GET_PAYMENT_METHOD_CREATED_BY_ERROR:
          return { ...state, loading: false, paymentCreatedByError: action.payload ? action.payload.message : "" };
       
  
      
      default:
        return { ...state };
    }
  };